module.exports = __webpack_public_path__ + "static/NLB_ZlataLisica-bb758e66d9682953b529ec8991a86316.mp4";